<template>
    <div>
        <search v-model="search" @search="fetchData" placeholder="Search by company shortname or customer name..."/>

        <card>
            <card-header>
                FareHarbor Logs
            </card-header>
            <card-body class="pt-0" v-if="loading">
                <card-spinner size="large" style="height: 240px;"/>
            </card-body>
            <card-body class="p-0" v-else>
                <table class="table">
                    <thead>
                    <tr>
                        <th>Company Shortname</th>
                        <th>Customer Name</th>
                        <th>Booking Status</th>
                        <th>Booking Item Name</th>
                        <th>Booking End Date</th>
                        <th>Webhook Capture Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="log in logs.data" :key="log.id">
                        <td>{{ log.company_shortname}}</td>
                        <td>{{ log.customer_name }}</td>
                        <td>{{ log.booking_status }}</td>
                        <td>{{ log.booking_item_name }}</td>
                        <td>{{ log.booking_end_at | date}}</td>
                        <td>{{ log.created_at | date }}</td>
                    </tr>
                    </tbody>
                </table>
                <pagination v-if="logs.meta.last_page > 1" :meta="logs.meta" :links="logs.links" @page="setPage" />
            </card-body>
        </card>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                search: null,
                page: 1,
                logs: []
            };
        },

        created() {
            this.fetchData();
        },

        methods: {
            async fetchData() {
                this.loading = true;
                let params = { page: this.page, search: this.search };
                let { data } = await this.$http.get(this.$laroute.route('fareharbor-webhook.index'), { params });
                this.loading = false;
                this.logs = data;
            },

            setPage(page) {
                this.page = page;
                this.fetchData();
            }
        }
    };
</script>
